// @ts-ignore
import load from 'load-script';
import ObjectUtils from '@/utils/object-utils';
import JSONUtils from '@/utils/json-utils';
import Logger from './logger.utils';

export interface ScriptLoadOptions {
  async?: boolean;
  attrs?: any;
  charset?: string;
  text?: string;
  type?: string;
}

export default class DocumentUtils {
  public static getElementById(id:string): HTMLElement {
    return document.getElementById(id);
  }

  public static removeAllChildNodes(parent: HTMLElement) {
    while (parent.firstChild) {
      console.dir(parent.firstChild);
      parent.removeChild(parent.firstChild);
    }
  }
  public static getElementByTagName(tagName:string): HTMLCollectionOf<Element> {
    return document.getElementsByTagName(tagName);
  }

  public static createScriptElement(): HTMLScriptElement {
    return document.createElement('script');
  }
  // istanbul ignore next
  public static appendParentWithChild(parentElement: HTMLElement, childElement: HTMLElement): void {
    if (parentElement && childElement) {
      parentElement.appendChild(childElement);
    }
  }
  // istanbul ignore next
  public static replaceHtmlElementName(original: HTMLElement, newElementName: string): void {
    const replacement: HTMLElement = document.createElement(newElementName);
    for (let i = 0, l = original.attributes.length; i < l; ++i) {
      const nodeName: string = original.attributes.item(i).nodeName;
      const nodeValue: string | null = original.attributes.item(i).nodeValue;
      replacement.setAttribute(nodeName, (nodeValue));
    }
    replacement.innerHTML = original.innerHTML;
    original.parentNode.replaceChild(replacement, original);
  }

  public static appendChild(childElement: HTMLScriptElement): void {
    if (childElement) {
      document.head.appendChild(childElement);
    }
  }

  public static createHTMLElement(htmlElement:string): HTMLElement {
    if (htmlElement) {
      return document.createElement(htmlElement);
    }
    return null;
  }

  public static appendScript(htmlScriptElement: HTMLScriptElement): void {
    if (htmlScriptElement) {
      document.head.appendChild(htmlScriptElement);
    }
  }
  public static createHTMLScriptElement(type: string, src: string): HTMLScriptElement {
    const script: HTMLScriptElement = document.createElement('script');
    script.src = src;
    script.type = type;
    return script;
  }

  // istanbul ignore next
  public static async loadScript(url: string, options: ScriptLoadOptions = { async: true }): Promise<HTMLScriptElement> {
    return new Promise<HTMLScriptElement>((resolve, reject) => {
      load(url, options, (error: any, script: HTMLScriptElement) => {
        if (error) {
          reject(error);
        } else {
          resolve(script);
        }
      });
    });
  }
  // istanbul ignore next
  static loadSrciptWithCallBack(src: string, opts: any, cb: Function) {
    load(src, opts, cb);
  }

  public static async loadWCUrl(url: string): Promise<HTMLScriptElement> {
    return new Promise<HTMLScriptElement>((resolve, reject) => {
      let pos1: number = 0;
      let pos2: number = 0;
      pos1 = url.indexOf('.esm.js');
      if (pos1 >= 0) {
        pos2 = pos1 + 7;
      } else {
        pos1 = url.indexOf('.js');
        if (pos1 >= 0) {
          pos2 = pos1 + 3;
        }
      }
      if (pos1 > 0 && pos2 > 0) {
        const str1: string = url.substring(0, pos1);
        const str2: string = url.substring(pos2);
        const moduleJs: string = `${str1}.esm.js${str2}`;
        const noModuleJs: string = `${str1}.js${str2}`;

        let callbackedInvoked: boolean = false;
        DocumentUtils.loadSrciptWithCallBack(moduleJs, { type: 'module' }, (error: any, script: HTMLScriptElement) => {
          if (moduleJs.indexOf('ol-nw-ui-wc-common-widgets.esm.js') > -1) {
            script.setAttribute('data-id', 'commonWidgetESM');
          }
          if (!callbackedInvoked) {
            if (!error) {
              callbackedInvoked = true;
              resolve(script);
            }
          }
        });
        DocumentUtils.loadSrciptWithCallBack(noModuleJs, { attrs: { nomodule: '' } }, (error: any, script: HTMLScriptElement) => {
          if (!callbackedInvoked) {
            if (!error) {
              callbackedInvoked = true;
              resolve(script);
            }
          }
        });
      }
    });
  }

  public static getAttributeOrProperty(element: HTMLElement, name: string): any {
    return element.getAttribute(name) || (element as any)[name] || element.getAttribute(name.toLowerCase()) || (element as any)[name.toLowerCase()];
  }

  public static getDocumentBody(): HTMLElement {
    return document.body;
  }
  public static getAttributesOrProperties(element: HTMLElement): {[key: string]: any} {
    const attrsOrProps: {[key: string]: any} = {};
    const keys: Array<string> = JSONUtils.getKeys(element);
    ObjectUtils.getFirstNonNullOrNonUndefinedValue<Array<string>>(keys, []).forEach((key) => {
      attrsOrProps[key] = (element as any)[key];
    });
    const attrNames: Array<string> = element.getAttributeNames();
    ObjectUtils.getFirstNonNullOrNonUndefinedValue<Array<string>>(attrNames, []).forEach((attrName) => {
      const attrValue: string = element.getAttribute(attrName);
      if (attrName !== 'id') {
        attrsOrProps[attrName] = attrValue;
      }
    });
    return attrsOrProps;
  }

  public static getCookie(): string {
    return document.cookie;
  }
}
